import { Images, Tweens } from "@abcya/abcya_phaser";
import { centerSprite, strPadLeft } from "../phaserHelpers";

export default class GridDisplay extends Phaser.GameObjects.Container
{
	constructor(scene, game, atlasId, x, y)
	{
        if (x === void(0)) x = 0;
        if (y === void(0)) y = 0;

		super(scene, x, y);

        //this.game = scene;
        // this.sceneX = x;
        // this.sceneY = y;
        this.atlasId = atlasId;

        this.colCount = 9;
        this.rowCount = 9;
        this.gridSize = this.colCount*this.rowCount;

        this.tileSize = 72;//in pixels

        this.selectionSize = 4;//in tiles
        this.tileSetCount = 7;
        this.tileSetTypeCount = 5;

        this.maxColStarter = ~~(this.colCount - this.selectionSize/2);
        this.maxRowStarter = ~~(this.rowCount - this.selectionSize/2);

        this.curLevel = 1;
        this.posPoint = new Phaser.Math.Vector2(0,0);//tmp use throughout

        this.bg = this.scene.add.sprite(0,0,this.atlasId, "Grid_Bg").setOrigin(0);
        this.add(this.bg);
        this.bgTileDisplayStart = {x:27, y:27};

        this.tileGroup = this.scene.add.container();
        this.add(this.tileGroup);
        this.tileGroup.x = this.bgTileDisplayStart.x;
        this.tileGroup.y = this.bgTileDisplayStart.y;
        this.tileMatrix = [];
        this.spotMatrix = [];
        let counter = 1;
        for (let row=0;row<this.rowCount;row++)
        {
            for (let col=0;col<this.colCount;col++)
            {
                if (!this.spotMatrix[row]) this.spotMatrix[row] = [];
                if (!this.tileMatrix[row]) this.tileMatrix[row] = [];
                this.spotMatrix[row][col] = -1;
                let spritename = "Tile_" + strPadLeft(counter, "0", 3);
                this.getTilePosition(row,col);
                let sprite = Images.addImage(this.posPoint.x, this.posPoint.y, spritename, this.tileGroup);
                centerSprite(sprite);
                this.tileMatrix[row][col] = sprite;
                counter++;
                if (counter > 35) {
                    counter = 1;
                }
            }
        }
        // this.x = this.sceneX;
        // this.y = this.sceneY;
    }

    getTilePosition(row, col) {
        let tileX = col * this.tileSize + this.tileSize*0.5;
        let tileY = row * this.tileSize + this.tileSize*0.5;
        this.posPoint.x = tileX;
        this.posPoint.y = tileY;
        return this.posPoint;
    };

    initializeGridForLevel(level) {
        this.curLevel = level;
        this.maxTileTypeId = this.tileSetTypeCount * this.curLevel;

        let thisTileType = 0;
        for (let row=0;row<this.rowCount;row++)
        {
            for (let col = 0; col < this.colCount; col++)
            {
                thisTileType = Phaser.Math.RND.integerInRange(1, this.maxTileTypeId);
                this.spotMatrix[row][col] = thisTileType;
                this.tileMatrix[row][col].frameName = "Tile_" + strPadLeft(thisTileType, "0", 3);
                this.tileMatrix[row][col].setFrame("Tile_" + strPadLeft(thisTileType, "0", 3));
            }
        }
    };

    getPatternFromStarterTile(row,col, out) {
        if (out == void(0)) out = [[0,0],[0,0]];
        out[0][0] = this.spotMatrix[row][col];
        out[0][1] = this.spotMatrix[row][col+1];
        out[1][0] = this.spotMatrix[row+1][col];
        out[1][1] = this.spotMatrix[row+1][col+1];
    };

    getTileLocationFromMousePoint(x,y) {
        x -= this.x;
        y -= this.y;
        
        let row = this.snapToFloor(y-this.tileGroup.y, this.tileSize) / this.tileSize;
        let col = this.snapToFloor(x-this.tileGroup.x, this.tileSize) / this.tileSize;
        if (row < 0) row = 0;
        if (row >= this.rowCount-1) row = this.rowCount-2;
        if (col < 0) col = 0;
        if (col >= this.rowCount-1) col = this.rowCount-2;
        const pos = {x:this.tileMatrix[row][col].x+this.x+this.tileGroup.x,y:this.tileMatrix[row][col].y+this.y+this.tileGroup.y};
        return pos;
    };

    snapToFloor(input, gap, start) {

        if (start === undefined) { start = 0; }

        if (gap === 0) {
            return input;
        }

        input -= start;
        input = gap * Math.floor(input / gap);

        return start + input;

    };

    getTileRowColFromPoint(x,y) {
        x -= this.x;
        y -= this.y;
        const row = this.snapToFloor(y+this.tileGroup.y, this.tileSize) / this.tileSize;
        const col = this.snapToFloor(x+this.tileGroup.x, this.tileSize) / this.tileSize;
        if (row >= this.rowCount-1) row = -1;
        if (col >= this.colCount-1) col = -1;
        return [row,col];
    };

    getTilesRect() {
        const rect = new Phaser.GameObjects.Rectangle(this.scene, 0, 0, 0, 0);
        rect.left = this.tileGroup.x+this.x;
        rect.right = rect.left + this.tileSize*this.rowCount;
        rect.top = this.tileGroup.y+this.y;
        rect.bottom = rect.top + this.tileSize*this.colCount;
        return rect;
    };

    setNewPatternFromStarterTileWidthTransition = function(row, col) {
        this.setTilePatternWithFadeIn(row,col);
        this.setTilePatternWithFadeIn(row+1,col);
        this.setTilePatternWithFadeIn(row,col+1);
        this.setTilePatternWithFadeIn(row+1,col+1);
    };

    setTilePatternWithFadeIn = function(row, col) {
        let thisTileType = Phaser.Math.RND.integerInRange(1, this.maxTileTypeId)
        this.spotMatrix[row][col] = thisTileType;
        this.tileMatrix[row][col].frameName = "Tile_" + strPadLeft(thisTileType, "0", 3);
        this.tileMatrix[row][col].setFrame("Tile_" + strPadLeft(thisTileType, "0", 3));
        this.tileMatrix[row][col].alpha = 0;
        Tweens.addTween(this.tileMatrix[row][col], 1300, {alpha:1}, Phaser.Math.Easing.Quadratic.In);
    };

    newMaxTileType(value) {
        this.curLevel = value;
        this.maxTileTypeId = this.tileSetTypeCount * this.curLevel;
        this.maxTileTypeId = this.tileSetTypeCount * Math.min(this.curLevel,this.tileSetCount);
    };

    selectedWrongTiles(row, col) {
        if (row < 0 || col < 0 || row >= this.rowCount-1 || col >= this.colCount-1) return;
        this.tileRefadeIn(row,col);
        this.tileRefadeIn(row+1,col);
        this.tileRefadeIn(row,col+1);
        this.tileRefadeIn(row+1,col+1);
        return true;
    };

    tileRefadeIn(row, col) {
        if (row < 0 || col < 0 || row >= this.rowCount || col >= this.colCount) return;
        this.tileMatrix[row][col].alpha = 0;
        Tweens.addTween(this.tileMatrix[row][col], 820, {alpha:1}, Phaser.Math.Easing.Quadratic.In);
        return true;
    };
}
/*

    me.housekeeping = function() {
        for (var row=0;row<this.rowCount;row++)
        {
            for (var col = 0; col < this.colCount; col++) {
                this.tileMatrix[row][col].destroy();
            }
        }
        this.bg.destroy();
        this.bg = null;
        this.tileMatrix = null;
        this.spotMatrix = null;
    };

})();*/